import { render, staticRenderFns } from "./RefillBonusEditor.vue?vue&type=template&id=586f13c8&"
import script from "./RefillBonusEditor.vue?vue&type=script&lang=js&"
export * from "./RefillBonusEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports